import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChange,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { IBalooGroup, IBalooMatch } from '@fi-app/external-platform-integration/baloo/baloo';
import { ObjectTypes } from '@fi-shared/types';
import { PkMatchType } from '@fi-app/external-platform-integration/pk/pk-match-type';
import { isEqual } from '@fi-shared/utils';

@Component({
    selector: 'fi-baloo-match-roles-units',
    templateUrl: './baloo-match-roles-units.component.html',
    styleUrls: ['./baloo-match-roles-units.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-baloo-match-roles-units' },
    standalone: false,
})
export class BalooMatchRolesUnitsComponent implements OnChanges {
    @Input() balooGroups: IBalooGroup[];
    @Input() matches: IBalooMatch[];
    @Input() allGroupMatches: IBalooMatch[];
    @Input() objectType: ObjectTypes;
    @Input() isSaveButtonDisabled: boolean = true;
    @Output() matchChange: EventEmitter<IBalooMatch> = new EventEmitter<IBalooMatch>();
    @Output() onSaveMatch: EventEmitter<void> = new EventEmitter<void>();

    matchSections: { [prop: number]: IBalooMatch[] };
    PkMatchType = PkMatchType;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        let change: SimpleChange = changes.balooGroups;

        if (change && !isEqual(change.currentValue, change.previousValue)) this.buildMatchSections();

        change = changes.matches;
        if (change && !isEqual(change.currentValue, change.previousValue)) this.buildMatchSections();
    }

    private buildMatchSections() {
        // clear sections
        this.matchSections = {};
        this.matchSections[PkMatchType.AutoMatched] = [];
        this.matchSections[PkMatchType.NotMatched] = [];
        this.matchSections[PkMatchType.PrevMatched] = [];
        // fill sections
        this.matches.forEach((match: IBalooMatch) => this.matchSections[match.InitialMatchType].push(match));
    }

    getMatchSectionByType(sectionType: PkMatchType): IBalooMatch[] {
        return this.matchSections[sectionType];
    }

    isMatchesVisible(): boolean {
        return (
            !!this.getMatchSectionByType(PkMatchType.NotMatched)?.length ||
            !!this.getMatchSectionByType(PkMatchType.PrevMatched)?.length
        );
    }

    saveMatch() {
        this.onSaveMatch.emit();
    }

    onMatchChange(match: IBalooMatch) {
        this.matchChange.emit(match);
    }

    /*
    getChainGroupDataTest(match: IBalooMatch) {
        let matchType: PkMatchType = PkMatchType.NotMatched;
        if (this.matchSections[PkMatchType.PrevMatched].indexOf(match) !== -1) {
            matchType = PkMatchType.PrevMatched;
        }

        return `${match.ObjectName} (${match.ObjectId}), ${PkMatchType[matchType]}`
    }

    getBalooGroupDataTest(match: IBalooMatch) {
        if (!match.BalooId)
            return '';
        return `${match.BalooName} (${match.BalooId})`
    }

     get matchesTest() { // for tests
        return this.matchSections[PkMatchType.NotMatched]
            .concat(this.matchSections[PkMatchType.PrevMatched]);
    }
    */
}
